import type { ReactNode } from "react";

import { Box, Collapse, Icon, Paper } from "@mui/material";
import { useState } from "react";

import { SubtitleText } from "~/components/Typographies";

interface ProfileSectionCardProps {
	children: ReactNode;
	defaultExpanded?: boolean;
	icon: string;
	title: string;
}

const ProfileSectionCard = ({ children, defaultExpanded = false, icon, title }: ProfileSectionCardProps) => {
	const [expanded, setExpanded] = useState(defaultExpanded);

	return (
		<Paper sx={{ borderRadius: 3, mb: 2.5, p: 2.5 }} variant="outlined">
			<Box
				aria-expanded={expanded}
				component="button"
				onClick={() => setExpanded((current) => !current)}
				sx={{
					alignItems: "center",
					background: "none",
					border: "none",
					cursor: "pointer",
					display: "flex",
					gap: 1.5,
					p: 0,
					textAlign: "left",
					width: "100%"
				}}
				type="button"
			>
				<Icon sx={{ color: "primary.main" }}>{icon}</Icon>
				<SubtitleText bold>{title}</SubtitleText>
				<Box sx={{ flex: 1 }} />
				<Icon
					sx={{
						color: "text.secondary",
						transform: expanded ? "rotate(180deg)" : "none",
						transition: "transform 0.2s ease"
					}}
				>
					expand_more
				</Icon>
			</Box>
			<Collapse in={expanded}>
				<Box sx={{ pt: 2 }}>{children}</Box>
			</Collapse>
		</Paper>
	);
};

export default ProfileSectionCard;
